interface IMoreOptionsIconProps {
  color?: string;
}

export const MoreOptionsIcon = ({ color = "currentColor" }: IMoreOptionsIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%", height: "100%" }}
    >
      <circle cx="12" cy="5" r="2" fill={color} />
      <circle cx="12" cy="12" r="2" fill={color} />
      <circle cx="12" cy="19" r="2" fill={color} />
    </svg>
  );
};
